var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sessionHasEnhancedTurns)?_c('div',{staticStyle:{"margin-top":"2vh"}},[_c('p',{staticStyle:{"margin-left":"1vw","font-size":"12px"}},[_vm._v("Body rotation update applied")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }